<template>
    <div class="list">
      <div class="classify" :title="title">{{title}}</div>
      <ul>
        <li v-for="(item,index) in items" :items="items" @click="$router.push(item.url)" style="cursor:pointer">
        {{item.listName}}<Icon type="ios-arrow-forward" size="26" color="#2F669A"/>
        <div class="butt-line"></div>
        </li>
      </ul>
    </div>
</template>

<script>
export default {
  name: 'List',
  props: {
    items: {
      type: Array,
      default () {
        return []
      }
    },
    title: {
      type: String,
      default () {
        return ''
      }
    }
  }
}
</script>

<style scoped>
  ul {
    list-style-type: none;
    background: #FFFFFF;
    margin: 0 auto;
    width: 80%;
    padding-bottom: 20px
  }
  li {
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
    height: 60px;
    line-height: 60px;
    font-size: 15px;
    position: relative;
  }
  .list {
    margin-top: 5px;
    width: 100%;
    height: 660px;
  }
  .classify {
    width: 80%;
    height: 80px;
    background: #2F669A;
    font-size: 25px;
    color: #FFFFFF;
    text-align: center;
    line-height: 80px;
    margin: 0 auto;
    box-shadow:5px 5px 10px gray;
    margin-bottom: 20px;
    border-radius: 5px;
  }
  .ivu-icon {
    position: absolute;
    right: 45px;
    line-height: 60px;
  }
  .butt-line {
    width: 80%;
    height: 5px;
    background: #2F669A;
    margin: 0 auto;
    opacity:0.4;
    border-radius: 5px;
    box-shadow:5px 5px 10px gray;
  }
</style>
